import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/StoryLibrary.css";

interface Story {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  coverColor: string;
  route: string;
}

const StoryLibrary: React.FC = () => {
  const [darkMode, setDarkMode] = useState(true);
  const navigate = useNavigate();

  const stories: Story[] = [
    {
      id: "graengale-grove",
      title: "Graengale Grove - Valora Elderleaf",
      subtitle: "Of the Elder Elves",
      description:
        "What began as a foray into forbidden lands, uncovers a reality that will shatter Valora's world in more ways than one. Ein verwunschenes Land lockt sie an, um ihr seine alte, furchtbare Mär zu künden.",
      coverColor:
        "linear-gradient(135deg, #2d5016 0%, #1a3a0f 50%, #0f2108 100%)",
      route: "/story/graengale-grove",
    },
    // Add more stories here in the future
  ];

  const handleStoryClick = (route: string) => {
    navigate(route);
  };

  return (
    <div className={`story-library ${darkMode ? "dark-mode" : "light-mode"}`}>
      <div className="library-header">
        <h1>Short Stories</h1>
        <button
          className="mode-toggle"
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle dark/light mode"
        >
          {darkMode ? "☀️" : "🌙"}
        </button>
      </div>

      <div className="library-subtitle">
        <p>A collection of atmospheric fantasy tales</p>
      </div>

      <div className="bookshelf">
        {stories.map((story) => (
          <div
            key={story.id}
            className="book"
            onClick={() => handleStoryClick(story.route)}
            style={{ background: story.coverColor }}
          >
            <div className="book-spine"></div>
            <div className="book-cover">
              <div className="book-title">{story.title}</div>
              <div className="book-subtitle">{story.subtitle}</div>
              <div className="book-ornament">✦</div>
            </div>
            <div className="book-description">
              <p>{story.description}</p>
              <button className="read-button">Read Story →</button>
            </div>
          </div>
        ))}

        {/* Placeholder books for future stories */}
        <div className="book placeholder">
          <div className="book-spine"></div>
          <div className="book-cover">
            <div className="book-title">Coming Soon</div>
            <div className="book-subtitle">More tales await...</div>
            <div className="book-ornament">✦</div>
          </div>
        </div>

        <div className="book placeholder">
          <div className="book-spine"></div>
          <div className="book-cover">
            <div className="book-title">Coming Soon</div>
            <div className="book-subtitle">More tales await...</div>
            <div className="book-ornament">✦</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryLibrary;
